import { useRtmpAccess } from '../use-rtmp-access';

const useRtmpDiscoverability = () => {
  const hasRtmpAccess = useRtmpAccess();
  return !hasRtmpAccess;
};

export default useRtmpDiscoverability;
